import { render, staticRenderFns } from "./single-meeting-point.vue?vue&type=template&id=33ff9d02&"
import script from "./single-meeting-point.vue?vue&type=script&lang=js&"
export * from "./single-meeting-point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports